/**
 * Functions for calculating phase costs based on port count and charger costs
 *
 * Also filters phases based on site if controls are passed
 */
export const calculatePhases = (
  phases,
  chargerCosts,
  controls,
  cityInfo,
  includeMasterAccessIncentives = false,
) => {
  let res = {};

  const phaseCosts = phases.map((phase) => {
    const chargerEquipmentCost =
      //round these calculations
      divideByTwo(phase.port_less_than_10_kw, cityInfo.port_count_1) *
        chargerCosts["cost_less_than_10_kw"] +
      divideByTwo(phase.port_10_20_kw, cityInfo.port_count_2) *
        chargerCosts["cost_10_20_kw"] +
      divideByTwo(phase.port_25_kw, cityInfo.port_count_3) *
        chargerCosts["cost_25_kw"] +
      divideByTwo(phase.port_180_200_kw, cityInfo.port_count_4) *
        chargerCosts["cost_180_200_kw"];
    let installCost = 0;
    installCost =
      divideByTwo(phase.port_less_than_10_kw, cityInfo.port_count_1) *
        chargerCosts["install_less_than_10_kw"] +
      divideByTwo(phase.port_10_20_kw, cityInfo.port_count_2) *
        chargerCosts["install_10_20_kw"] +
      divideByTwo(phase.port_25_kw, cityInfo.port_count_3) *
        chargerCosts["install_25_kw"] +
      divideByTwo(phase.port_180_200_kw, cityInfo.port_count_4) *
        chargerCosts["install_180_200_kw"];
    // Conditionally include master_access_incentives based on flag
    // This matches the logic in PhaseGrid.js line 677
    let totalIncentives =
      phase.incentives +
      (includeMasterAccessIncentives ? phase.master_access_incentives || 0 : 0);
    let chargerInfraTotal;

    return {
      ...phase,
      chargerEquipmentCost,
      installCost,
      totalIncentives,
      chargerInfraTotal,
    };
  });
  const sortedPhases = phaseCosts.sort((a, b) => a.id - b.id);

  if (controls) {
    const filteredPhases = sortedPhases.filter(
      (phase) => phase.site === controls.site || controls.site === "All Sites",
    );
    res.filteredPhases = filteredPhases;
  }
  res.phases = sortedPhases;

  return res;
};

const divideByTwo = (num, portCount) => Math.ceil(num / portCount);
